import Project from './Project';
import React from 'react';
import '../../App.css';
const Projects = props => {
    return (
      <section id="projects">
        <div className="projects-container">
          <div className="heading">
            <h3 className="title">My Works</h3>
            <p className="separator" />
          </div>
          <div className="projects-wrapper">
            <Project
              title="Search Companion Website."
              tech="js css react react-router"
              link="https://devanshi-123.github.io/SearchCompanion/#/poozle/images"
              repo="https://github.com/Devanshi-123/SearchCompanion"
            >
              <small>
                Built using Different Api's, React.js,Redux and React Router.
              </small>
              <p>
                This is a  website that I made which lets the user search any video image or recipe of their 
                choice and get in a proper grid fashion.
              </p>
            </Project>
            <Project
              title="Stock Price Prediction."
              tech="Machine Learning,Different Ensemble Learning Methods"
              repo="https://github.com/Devanshi-123/stock_market_prediction"
            >
              <small>
                Built using different machine learning and deep learning algorithms.
              </small>
              <p>
               A machine learning model made to inspect the upcoming prices of Tehran stock exchange
              </p>
            </Project>
            <Project
              title="Weather App"
              tech="js node css"
              link="https://git.heroku.com/goel-weather-forecast.git"
              repo="https://github.com/Devanshi-123/nodejs-weather-website"
            >
              <small>Built using Node, Express, JS and CSS.</small>
              <p>
                A full stack website which would return the temperature ,probability 
                of rain etc depending on the location
              </p>
            </Project>
            <Project
              title="Technical Documentation Page"
              tech="html css"
              link="https://codepen.io/Devanshi_Goel/pen/RwGBGLw"
              repo="https://codepen.io/Devanshi_Goel/pen/RwGBGLw"
            >
              <small>Built using html and css in a responsive format</small>
              <p>Documentation to maintain a crux of different topics at one place</p>
            </Project>
            <Project
              title="Survey Form"
              tech="html css"
              link="https://codepen.io/Devanshi_Goel/pen/oNzdGzW"
              repo="https://codepen.io/Devanshi_Goel/pen/oNzdGzW"
            >
              <small>Built using HTML and CSS</small>
              <p>
                Responsive Feedback Form made using HTML and CSS
                some other responsive pages at 
                <a href="https://codepen.io/Devanshi_Goel" target="blank"> Codepen</a>
              </p>
            </Project>
            <Project
              title="Mood Music"
              tech="machine learning"
              link="https://github.com/Devanshi-123/Mood-Detection"
              repo="https://github.com/Devanshi-123/Mood-Detection"
            >
              <small>Built using machine learning algorithms.</small>
              <p>It will predict the mood of a person based on the song one is listening to.</p>
            </Project>
            <Project
              title="Streamers App"
              tech="react redux react-router"
              link="https://drive.google.com/file/d/1imEWDXIEMHMKW3VH8GibMR4lV5oUk-kQ/view?usp=sharing"
              repo="https://github.com/Devanshi-123/Streamers_Space"
            >
              <p>Live streaming website which allows users to directly live stream their video/audio by just  configuring their OBS to the servers URL with the Stream Key equal to the ID of the stream created with the react app and audience can view that stream at that url.</p>
            </Project>
            <Project
              title="Synergy"
              tech="M.E.R.N"
              link="https://lets-grow-together.herokuapp.com/"
              repo="https://github.com/Devanshi-123/Synergy"
            >
              <p>Synergy helps content creators share their resources topic wise and peers to learn from them and upvote their favourite one which can help other learners.</p>
            </Project>
            <Project
              title="Apna Store"
              tech="M.E.R.N"
              link="https://apnaprovisionstore.herokuapp.com/"
              repo="https://github.com/Devanshi-123/ApniDukaan"
            >
              <p>ApnaStore is an online store where shopkeepers can manage their products, customers,can track orders and the customers can place their order by selecting the desired product.My father is planning to use it in future for his provision store as well.</p>
            </Project>
            <Project
              title="Muckin"
              tech="M.E.R.N"
              link="https://muckin.netlify.app/"
              repo="https://github.com/dscnitp/ngo-donations-site"
            >
              <p>A website for connecting people who are looking for help and those willing to help(Worked as a project lead in a team DSC NITP).</p>
            </Project>
            <Project
              title="Worklink"
              tech="M.E.R.N"
              link="https://worklink.netlify.app/"
              repo="https://github.com/dscnitp/job-provider-site"
            >
              <p>Website for helping the labourers,etc for searching jobs and customers for finding the skilled labour(Worked as a project lead in a team DSC NITP)</p>
            </Project>
            <Project
              title="Profiling Hate Speech Spreaders"
              tech="TechStack - LSTM,KNN,Naive Bayes,Tfidf,Count Vectorizer,ngrams,NLP"
              repo="https://github.com/Devanshi-123/Hate_Speech_Spreaders"
            >
              <p>Model identifies  hate speech spreaders on twitter .for english and spanish language on the
two dataset provided by PAN @CLEF 2021.Naive Bayes gave best result with accuracy of 0.74 for english and 0.82 for spanish. (Minor Project under J.P Singh Sir).</p>
            </Project>
          </div>
        </div>
      </section>
    );
  };

  export default Projects;
  